var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReceiptItem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.333 5.00008V7.01675C18.333 8.33341 17.4997 9.16675 16.183 9.16675H13.333V3.34175C13.333 2.41675 14.0913 1.66675 15.0163 1.66675C15.9247 1.67508 16.758 2.04175 17.358 2.64175C17.958 3.25008 18.333 4.08341 18.333 5.00008Z",
    stroke: "#2DA7FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 5.83341V17.5001C1.66699 18.1917 2.45033 18.5834 3.00033 18.1668L4.42533 17.1001C4.75866 16.8501 5.22533 16.8834 5.52533 17.1834L6.90866 18.5751C7.23366 18.9001 7.76699 18.9001 8.09199 18.5751L9.49199 17.1751C9.78366 16.8834 10.2503 16.8501 10.5753 17.1001L12.0003 18.1668C12.5503 18.5751 13.3337 18.1834 13.3337 17.5001V3.33341C13.3337 2.41675 14.0837 1.66675 15.0003 1.66675H5.83366H5.00033C2.50033 1.66675 1.66699 3.15841 1.66699 5.00008V5.83341Z",
    stroke: "#2DA7FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.8416H10",
    stroke: "#2DA7FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5083H10",
    stroke: "#2DA7FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99609 10.8333H5.00358",
    stroke: "#2DA7FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99609 7.5H5.00358",
    stroke: "#2DA7FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptItem);
export default __webpack_public_path__ + "static/media/receipt-item.155e866fa9fdad643134d16343dfde5f.svg";
export { ForwardRef as ReactComponent };